module.exports = __webpack_public_path__ + "img/EG.db7b7673.svg";